export default "__VITE_ASSET__e0259115__"